export async function customerIndexUseCase(is_national, page, per_page, search, sort_by, customerRepostitory) {
    const result = await customerRepostitory.index(is_national, page, per_page, search, sort_by);

    result.data.data.forEach(x =>  {
        const entity = new customerRepostitory.model_index(x);

        if (!entity.isValid()) {
            throw new Error("customer inválido");
        }
    })

    return result.data;
}